import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import axiosInstance from "./axios";

import { PostDataT } from "../types/commonTypes";
import {
  PurchaseEntryProductResponseT,
  PurchaseReturnResponseT,
  UpdatePurchaseReturnDataRequestType,
} from "../types/purchaseReturnTypes";
import { PurchaseReturnSchemaT } from "../pages/NewPurchaseFormReturn";

export const useInfiniteGetAllPurchaseReturn = (postData: PostDataT) => {
  return useInfiniteQuery({
    queryKey: [`useGetAllPurchaseReturn`, postData.purchaseReturnNumber],
    queryFn: async () => {
      const { data } = await axiosInstance.get(`/purchase-entry/return/all`, {
        params: postData,
      });
      return data as PurchaseReturnResponseT & { hasNextPage?: boolean };
    },
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = lastPage.hasNextPage ? allPages.length + 1 : undefined;
      return nextPage;
    },
    initialPageParam: 1,
    refetchOnWindowFocus: false, // Add this to prevent refetch on window focus
  });
};

export const useGetPurchaseReturnEntry = ({ purchaseNumber }: any) => {
  return useQuery({
    queryKey: ["useGetPurchaseReturnEntry", purchaseNumber],
    queryFn: async () => {
      const { data } = await axiosInstance.get(
        `/purchase-entry/purchaseNumber?purchaseNumber=${purchaseNumber}`,
      );
      return data as PurchaseEntryProductResponseT;
    },
    enabled: !!purchaseNumber,
  });
};

export const useGetAPurchaseReturnEntry = ({ purchaseNumber }: any) => {
  return useQuery({
    queryKey: ["useGetPurchaseReturnEntry", purchaseNumber],
    queryFn: async () => {
      const { data } = await axiosInstance.get(
        `/purchase-entry/purchaseNumber?purchaseNumber=${purchaseNumber}`,
      );
      return data as PurchaseEntryProductResponseT;
    },
    enabled: !!purchaseNumber,
  });
};

export const useEditPurchaseReturnEntry = ({ purchaseNumber }: any) => {
  return useQuery({
    queryKey: ["useGetPurchaseReturnEntry", purchaseNumber],
    queryFn: async () => {
      const { data } = await axiosInstance.get(
        `/purchase-entry/return/${purchaseNumber}`,
      );
      return data as PurchaseReturnResponseT;
    },
    enabled: !!purchaseNumber,
  });
};

export const useSavePurchaseEntryReturn = () => {
  return useMutation({
    mutationKey: ["useSavePurchaseEntryReturn"],
    mutationFn: async (postData: PurchaseReturnSchemaT) => {
      const { data } = await axiosInstance.post(
        "/purchase-entry/return",
        postData,
      );
      return data as any;
    },
  });
};

export const useDeletePurchaseEntryReturn = () => {
  return useMutation({
    mutationKey: ["useDelPurchaseEntryReturn"],
    mutationFn: async (entryId: string | undefined) => {
      const { data } = await axiosInstance.delete(
        `/purchase-entry/return?purchaseReturnId=${entryId}`,
      );
      return data;
    },
  });
};

export const useUpdatePurchaseEntryReturn = () => {
  return useMutation({
    mutationKey: ["useUpdatePurchaseEntryReturn"],
    mutationFn: async (postData: UpdatePurchaseReturnDataRequestType) => {
      const { data } = await axiosInstance.put(
        "/purchase-entry/return",
        postData,
      );
      return data;
    },
  });
};
